import React from "react";
import { Chip, Typography } from "@mui/material";

import { HubTableTemplate } from "../../components";
import ContactContextMenu from "./ContactContextMenu";

const items = [
  { id: "primary", label: "Primary" },
  { id: "name", label: "Name" },
  { id: "title", label: "Title" },
  { id: "email", label: "Email" },
  { id: "phone", label: "Phone Number" },
  { id: "workPhone", label: "Work Number" },
];

const keys = [
  {
    value: "isPrimary",
    CustomComponent: ({ item }) =>
      item?.isPrimary ? (
        <Chip
          label="Primary"
          size="small"
          sx={{
            fontSize: 10,
            fontWeight: 600,
            height: 20,
            backgroundColor: "hubColors.mainFocusLightest",
            color: "hubColors.mainFocus",
            border: "1px solid",
            borderColor: "hubColors.mainFocusLight",
          }}
        />
      ) : null,
  },
  { value: "name" },
  { value: "title", defaultValue: "—" },
  { value: "email", defaultValue: "—" },
  { value: "phoneNumber", defaultValue: "—" },
  { value: "workNumber", defaultValue: "—" },
];

const ContextMenu = ({ item }) => <ContactContextMenu id={item?.id} />;

export const CustomerContactsTable = ({
  contacts = [],
  onRowClick = () => {},
}) => {
  return (
    <HubTableTemplate
      id="CustomerContactsTable"
      headerProps={{ items, includeEnd: true }}
      bodyProps={{
        items: contacts,
        keys,
        ContextMenu,
        onRowClick,
      }}
    />
  );
};

export default CustomerContactsTable;
